import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { postLogout } from "pages/Login/apis/login";
import { currentBsdState } from "pages/Login/atom/currentBsdState";
import { userLevelState } from "pages/Login/atom/userLevelState";
import { userState } from "pages/Login/atom/userState";
import { currentBsdListState, registedAlarmSetListState } from "pages/atom/globalState";

function Logout() {
  const navigate = useNavigate();
  const [, setUser] = useRecoilState(userState);
  const [, setUserLevel] = useRecoilState(userLevelState);
  const [, setBsdState] = useRecoilState(currentBsdState);
  const [, setBsdListState] = useRecoilState(currentBsdListState);
  const [, setAlarmSetListState] = useRecoilState( registedAlarmSetListState );

  useEffect(() => {
    const logout = async () => {
      // 사용자 인증 정보 초기화
      setUser(false);
      setUserLevel("Logout");

      // 기존 Header에서 처리하던 전역 데이터 초기화
      setBsdState("");
      setBsdListState([]);
      setAlarmSetListState([]);

      // 서버 로그아웃
      await postLogout();

      // 로그인 페이지 이동
      navigate("/", {
        replace: true,
      });
    };

    logout();
  }, [
    navigate,
    setUser,
    setUserLevel,
    setBsdState,
    setBsdListState,
    setAlarmSetListState,
  ]);

  return null;
}

export default Logout;
